/**
 * Enumeration of video sources that can be used in video editables.
 */
export enum VideoSource {
    YOUTUBE = 'YOUTUBE',
    VIMEO = 'VIMEO',
    DAILYMOTION = 'DAILYMOTION',
    TIKTOK = 'TIKTOK',
    FACEBOOK = 'FACEBOOK',
}
